export default __webpack_public_path__ + "static/media/filter-icon.71ebe582.svg";